import { useEffect, useState } from "react";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export const ProgressBar = ({ currentStep, totalSteps }: ProgressBarProps) => {
  const prevStep = Math.max(currentStep - 1, 0);
  const [width, setWidth] = useState(`${(prevStep / totalSteps) * 100}%`);

  useEffect(() => {
    setWidth(`${(currentStep / totalSteps) * 100}%`);
  }, [currentStep, totalSteps]);

  return (
    <div className="bg-secondary relative h-1.5 w-32 overflow-hidden rounded-full">
      <div
        className="bg-circle absolute left-0 top-0 h-full rounded-full transition-all duration-500 ease-in-out"
        style={{ width }}
      />
    </div>
  );
};
